import React from "react";
import {ProductionOrderFormTemplate} from "./ProductionOrderFormTemplate";

export function ProductionOrderFormCreate () {
    return (
        <ProductionOrderFormTemplate/>
    )
}